import { WarningCircle } from 'phosphor-react'

type NoContentProps = {
  message: string
}

export const NoContent = ({ message }: NoContentProps) => {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-2 text-sm text-center font-['DM_Sans'] text-grey-800 md:text-xl">
      <WarningCircle className="text-4xl" />
      <p>{message}</p>
    </div>
  )
}
